import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App"; // corrigido, se App.tsx está na mesma pasta
import "./index.css"; // Isso deve existir no topo


const root = ReactDOM.createRoot(document.getElementById("root")!);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
